<template>
  <div class="main main-padding">
    <!-- 顶部图像 -->
    <div class="title-container">
      <div class="title-text">{{ schoolName }}</div>
    </div>
    <div class="content-container" style="display: flex;justify-content: center;">
      <!-- 左边统计报表 -->
      <div class="content-box-item left-box" v-on:click="lookStatisData">
        <div class="left-img">
          <img src="../../assets/images/roleSelect/dataReport.png" width="100%" height="100%">
        </div>
        <div class="content-text">
          <span class="text-line">进入统计报表</span>
        </div>
      </div>
      <!-- 中间分隔线 -->
      <div class="divider-line"></div>
      <!-- 右边数据展板 -->
      <div class="content-box-item right-box" v-on:click="lookDashBoard">
        <div class="right-img">
          <img src="../../assets/images/roleSelect/dataBoard.png" width="100%" height="100%">
        </div>
        <div class="content-text">
          <span class="text-line">进入数据展板</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { findSchoolInfoById } from "../../service/api.js";
import { getPublicConfigBySchoolInfoApi } from "../../service/bigDataApi";

export default {
  name: 'school-main',
  computed: {
    ...mapGetters([
      'schoolName',
      'schoolId',
      'userId',
      'token'
    ]),
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 查看统计报表
     */
    lookStatisData() {
      // let routeData = this.$router.resolve({
      //     name: "boardMain",
      //     query: {
      //         schoolId: this.schoolId,
      //         schoolName: this.schoolName
      //     }
      // });
      // window.open(routeData.href, "_blank");
      let routeData = "/mobile/schoolBoard/" + this.schoolId + '/' + this.schoolName + '?userid=' + this.userId + '&token=' + this.token;
      window.open(routeData, "_blank");
    },
    /**
     * 查看数据展板
     */
    lookDashBoard() {
      this.findSchoolCode();
    },
    /**
     * 根据学校id获取学校编码
     */
    async findSchoolCode() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId
      };
      await findSchoolInfoById(params)
        .then(function (data) {
          //根据学校id获取学校编码
          // let routeData = _this.$router.resolve({
          //     name: "databorad",
          //     params: {
          //         schoolCode: data.schoolCode
          //     }
          // });

          let routeData = _this.$router.resolve({
            name: _this.schoolId == '75047a8a0990480f8abf3a39bc25f1ab' ? 'cloudschooldataboard' : "schooldataboard",
            params: {
              schoolId: _this.schoolId,
              schoolCode: data.schoolCode
            },
            query: {
              userid: _this.userId
            }
          });
          window.open(routeData.href, "_blank");
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
@import "../../style/home";
@import "../../style/schoolMain";

.title-container {
  background: {
    image: url("../../assets/images/roleSelect/title.png");
    repeat: no-repeat;
    size: cover;
    poisitn: top;
  }
}

.future-classroom {
  position: relative;
  height: 60px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 100px;

  span {
    font-family: Microsoft YaHei;
    font-weight: bold;

    font-size: 20px;
  }
}
</style>
